import autobind from 'core-decorators/lib/autobind';
import debounce from 'core-decorators/lib/debounce';

import PaymentEvents from 'shared/components/payment-events/payment-events';


export default class ReloadChannelPaymentDataOnPayment extends React.Component {
  static propTypes = {
    channelPaymentData: React.PropTypes.object,
  };

  @autobind
  @debounce
  fetchChannelPaymentData() {
    const { channelPaymentData } = this.props;

    if (channelPaymentData) {
      channelPaymentData.fetch();
    }
  }

  render() {
    return (
      <PaymentEvents onAnyEvent={this.fetchChannelPaymentData} />
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/data-components/reload-channel-payment-data-on-payment.js